// extracted by mini-css-extract-plugin
module.exports = {"Content":"Layout_Content__37oK7","pageTitle":"Layout_pageTitle___zDL7"};